import React from "react";
import "../../components/Skeleton/Skeleton.scss";
import ProductGridSkeleton from "../../components/ProductGridSkeleton/ProductGridSkeleton";
import "./HomeSkeleton.scss";

function HomeSkeleton() {
  return (
    <div
      className="home-skeleton"
      aria-busy="true"
      aria-label="Loading home"
    >
      <div className="home-skeleton__hero skeleton-shimmer" />
      <div className="home-skeleton__heading skeleton-shimmer" />
      <ProductGridSkeleton className="shop" count={4} />
      <div className="home-skeleton__heading home-skeleton__heading--second skeleton-shimmer" />
      <ProductGridSkeleton className="shop" count={4} />
    </div>
  );
}

export default HomeSkeleton;
